import styled from 'styled-components';
import { typography } from '@everlywell/leaves';

import { ariesTheme } from 'styles/ariesTheme';

const Wrapper = styled.div`
  font-weight: ${typography.weight.regular};
  color: rgb(
    ${props => props.theme.primaryDangerColor || ariesTheme.primaryDangerColor}
  );
  font-size: 14.2px;
  line-height: 2.11;
  letter-spacing: 0.1px;
  margin-top: 6px; /* don't let any absolute blur elements cover up part of message */
`;

export { Wrapper };
